// Lib
import React, { useEffect, useState } from 'react'
import { Modal } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import { useSearchParams } from 'react-router-dom'

// Images
import closeSVG from 'images/commons/close.svg'

// Include in project
import styles from './index.module.scss'
import { Button } from 'component'
import { Props } from './config'
import { CardPointSummary, HeadOfPointHistory, CardTotalPointHistory, PointTransaction } from 'container'
import { useReviewPointHistoryDetail } from 'hooks'
import { ETranformationDataIntoTable, transformationDataIntoTable } from 'utils/tranformData'
import { ECampaignType } from 'utils/generated'

const ModalOfCheckPoints: React.FC<Props> = (props: Props) => {
  const { values, setFieldValue } = useFormikContext<any>()
  const { t } = useTranslation()
  const [detailPoint, setDetailPoint] = useState<any>('')
  const [pointTransaction, setPointTransaction] = useState<any>([])
  const [searchParams] = useSearchParams()

  const { getReviewPointDetail } = useReviewPointHistoryDetail()

  useEffect(() => {
    if (!props.isOpen) return

    const variables: { campaignId?: string; shopId?: number; shopType?: string; month?: number; year?: number } = {}
    variables.campaignId = searchParams.get('campaignID') as string
    variables.shopId = values.pointHistoryDetail.shopID
    variables.shopType = values.pointHistoryDetail.shopType
    if (values.campaignDetail[0].campaignType === ECampaignType.Normal) {
      variables.month = values.filter.month
      variables.year = values.filter.year
    }
    getReviewPointDetail({
      variables: variables,
    }).then((res) => {
      if (res.data.reviewPointHistoryDetail.res_code === '99') return

      setDetailPoint(res.data.reviewPointHistoryDetail)
      setPointTransaction(res.data.reviewPointHistoryDetail?.pointTransaction)
    })
  }, [props.isOpen])

  const dataTransaction = transformationDataIntoTable({
    type: ETranformationDataIntoTable.ListPointTransaction,
    dataList: pointTransaction,
  })

  return (
    <Modal open={props.isOpen} onClose={props.onClose}>
      <section className={styles.containerModal}>
        <div className={styles.wrapperCard}>
          <div className={styles.head}>
            <h3>{t<string>('checkPointCamapaign.pointHistory')}</h3>
            <img src={closeSVG} alt="closeSVG" onClick={props.onClose} />
          </div>

          <section className={styles.groupCard}>
            <div className={styles.card}>
              <HeadOfPointHistory data={detailPoint} />
              <CardPointSummary dataList={detailPoint} />
            </div>
            <div className={styles.wrapperButton}>
              <CardTotalPointHistory
                title={t<string>('checkPointCamapaign.pointTotal')}
                unit={t<string>('common.star')}
                summary={detailPoint.point}
              />
              <Button
                type="primary"
                disabled={false}
                typeButton="button"
                name={t<string>('checkPointCamapaign.pointAdjust')}
                functionOnClick={() =>
                  setFieldValue('modal', {
                    ...values.modal,
                    isOpenModalPointAdjustment: !values.modal.isOpenModalPointAdjustment,
                  })
                }
              />
            </div>
          </section>

          <div className={styles.card}>
            <PointTransaction
              campaignName={detailPoint.campaignName}
              dataList={dataTransaction}
              fileName={`${searchParams.get('campaignID')}-${values.pointHistoryDetail.shopName}-${
                values.pointHistoryDetail.shopType
              }`}
            />
          </div>
        </div>
      </section>
    </Modal>
  )
}
export default ModalOfCheckPoints
